/* Isolated header behavior; existing theme cart/product code owns commerce. */
if (!customElements.get('foundation-header')) {
  customElements.define('foundation-header', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-fa-open]');
        if (opener) {
          const dialog = this.querySelector(`#${CSS.escape(opener.getAttribute('aria-controls'))}`);
          if (dialog) { this.opener = opener; opener.setAttribute('aria-expanded', 'true'); dialog.showModal(); }
        }
        const closer = event.target.closest('[data-fa-close]');
        if (closer) closer.closest('dialog').close();
        const parentLink = event.target.closest('summary a');
        if (parentLink) event.stopPropagation();
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => {
          this.opener?.setAttribute('aria-expanded', 'false');
          this.opener?.focus();
        }, options);
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        }, options);
      });
      this.querySelectorAll('.fa-desktop-nav > ul > li > details').forEach(details => {
        let openTimer, closeTimer;
        const open = () => {
          clearTimeout(closeTimer);
          this.querySelectorAll('.fa-desktop-nav details[open]').forEach(other => { if (other !== details) other.open = false; });
          details.open = true;
        };
        details.addEventListener('pointerenter', () => { if (matchMedia('(hover:hover)').matches) { clearTimeout(closeTimer); openTimer = setTimeout(open, 100); } }, options);
        details.addEventListener('pointerleave', () => { clearTimeout(openTimer); closeTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 250); }, options);
        details.addEventListener('focusin', () => { if (!this.escapeClosing) open(); }, options);
        details.addEventListener('focusout', event => { if (!details.contains(event.relatedTarget)) details.open = false; }, options);
        details.addEventListener('toggle', () => details.querySelector('summary').setAttribute('aria-expanded', String(details.open)), options);
      });
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.closeMenus(); }, options);
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.closeMenus(true); }, options);
    }
    closeMenus(restoreFocus = false) { this.escapeClosing = true; this.querySelectorAll('.fa-desktop-nav details[open]').forEach(d => { d.open = false; if (restoreFocus) d.querySelector('summary').focus(); }); queueMicrotask(() => { this.escapeClosing = false; }); }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
